import { CheckoutSessionPayload, CheckoutSessionResponse } from '@/app/api/payments/stripe/checkout/types';
import { SubscriptionDataResponse } from '@/app/api/payments/stripe/subscription/route';
import { SetupSessionPayload, SetupSessionResponse } from '@/app/api/payments/stripe/checkout/setup/types';
import { TrialingCheckoutPayload, TrialingCheckoutResponse } from '@/app/api/payments/stripe/checkout/trialing/types';
import type { ProductPricesApiResponse, ProductPricesQueryParams } from '@/app/api/payments/stripe/product-data/types';
import { User } from '@/generated/prisma';
import { ROUTE, axiosInstance } from './axiosInstance';

export const payments = {
  checkout: async ({ uiMode, productPriceId, successUrl, cancelUrl }: CheckoutSessionPayload) => {
    const { data } = await axiosInstance.post<CheckoutSessionResponse>(ROUTE.PAYMENTS.CHECKOUT, {
      uiMode,
      productPriceId,
      successUrl,
      cancelUrl,
    });
    return data;
  },

  checkoutSetup: async ({ subscriptionId, successUrl, cancelUrl }: SetupSessionPayload) => {
    const { data } = await axiosInstance.post<SetupSessionResponse>(ROUTE.PAYMENTS.CHECKOUT_SETUP, {
      subscriptionId,
      successUrl,
      cancelUrl,
    });
    return data;
  },

  checkoutTrialing: async ({ priceId, subscriptionStartDate, currentSubscriptionId, successUrl, cancelUrl }: TrialingCheckoutPayload) => {
    const { data } = await axiosInstance.post<TrialingCheckoutResponse>(ROUTE.PAYMENTS.CHECKOUT_TRIALING, {
      priceId,
      subscriptionStartDate,
      currentSubscriptionId,
      successUrl,
      cancelUrl,
    });
    return data;
  },

  getSubscription: async ({ subscriptionId }: { subscriptionId: string }) => {
    const { data } = await axiosInstance.get<SubscriptionDataResponse>(ROUTE.PAYMENTS.SUBSCRIPTION, {
      params: { subscriptionId },
    });
    return data;
  },

  billingPortal: async ({ stripeCustomerId }: Pick<User, 'stripeCustomerId'>) => {
    const { data } = await axiosInstance.get<{ url: string }>(ROUTE.PAYMENTS.BILLING, {
      params: {
        customerId: stripeCustomerId,
      },
    });
    return data;
  },

  getProductData: async ({ productId }: ProductPricesQueryParams) => {
    const { data } = await axiosInstance.get<ProductPricesApiResponse>(ROUTE.PAYMENTS.PRODUCT_DATA, {
      params: {
        productId,
      },
    });
    return data;
  },
};
